export enum WebSocketTopic {
    SyncStatus = 0,
    PublicNodeStatus = 1,
    NodeStatus = 2,
    BPSMetrics = 3,
    Milestone = 4,
    PeerMetric = 5,
    ConfirmedMsMetrics = 6,
    Vertex = 7,
    SolidInfo = 8,
    ConfirmedInfo = 9,
    MilestoneInfo = 10,
    TipInfo = 11,
    DBSizeMetric = 12,
}
